export const TRAINING_MODE_ALLOWED_PREFIXES = [
  "/training",
  "/assignments/launch",
  "/playbook",
  "/dashboard",
  "/dashboard/learning-paths",
  "/dashboard/transcript-results",
  "/dashboard/discovery/results",
  "/dashboard/pitch/results",
  "/dashboard/objections/results",
  "/dashboard/plays/results",
  "/dashboard/cold-call/results",
  "/dashboard/on-the-fly/results",
  "/dashboard/management/results",
  "/learning-paths",
  "/leaderboard",
  "/chats",
  "/dashboard/role-plays/assignments",
  "/simulator",
  "/tests/assignments",
  "/faq-tests",
  "/glossary-tests",
  "/settings",
  "/reset-password",
  "/stories/builder",
  "/api",
];

function matchesAllowedPrefix(pathname, prefix) {
  return pathname === prefix || pathname.startsWith(`${prefix}/`);
}

export function isTrainingModeAllowedPath(pathname = "") {
  if (typeof pathname !== "string" || !pathname.trim()) {
    return false;
  }

  return TRAINING_MODE_ALLOWED_PREFIXES.some((prefix) =>
    matchesAllowedPrefix(pathname, prefix)
  );
}
